import React from "react";
import "./style.css";

export default function SubCategoryCardTabs({ name, uid, slug, selected, onClick }) {
    return (
        <div
            className={selected ? "sub_category_card_tab selected" : "sub_category_card_tab"}
            onClick={onClick}
        >
            <p>{name}</p>
        </div>
    );
}
